module.exports = __webpack_public_path__ + "img/rm3.0114952e.jpg";